/* ws_style-with — arrow navigation for the "Style with" carousel.
   Scrolls the scroll-snap track by one card width; disables arrows at the ends.
   Lightweight, no dependencies, no work until connected. */
(function () {
  if (customElements.get('ws-style-with')) return;

  class WsStyleWith extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ws_style-with__track');
      this.prev = this.querySelector('.ws_style-with__arrow--prev');
      this.next = this.querySelector('.ws_style-with__arrow--next');
      if (!this.track) return;

      this._onPrev = function () { this.scrollByCard(-1); }.bind(this);
      this._onNext = function () { this.scrollByCard(1); }.bind(this);
      if (this.prev) this.prev.addEventListener('click', this._onPrev);
      if (this.next) this.next.addEventListener('click', this._onNext);

      this._onScroll = this.updateArrows.bind(this);
      this.track.addEventListener('scroll', this._onScroll, { passive: true });

      this.updateArrows();
      requestAnimationFrame(this.updateArrows.bind(this));
    }

    cardWidth() {
      var card = this.track.querySelector('.ws_style-with__card');
      if (!card) return this.track.clientWidth;
      var cs = getComputedStyle(this.track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByCard(dir) {
      this.track.scrollBy({ left: dir * this.cardWidth(), behavior: 'smooth' });
    }

    updateArrows() {
      var t = this.track;
      var atStart = t.scrollLeft <= 1;
      var atEnd = t.scrollLeft + t.clientWidth >= t.scrollWidth - 1;
      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd;
    }

    disconnectedCallback() {
      if (this.prev) this.prev.removeEventListener('click', this._onPrev);
      if (this.next) this.next.removeEventListener('click', this._onNext);
      if (this.track) this.track.removeEventListener('scroll', this._onScroll);
    }
  }

  customElements.define('ws-style-with', WsStyleWith);
})();
